import React from 'react'
import { Grid, GridItem } from '../../components/grid'
import css from './style.css'

const GradingLabSection = props => {
  return (
    <div>
      <Grid>
        <GridItem col='1/10' customStyle={css.gridItem} />
        <GridItem col='3/10' customStyle={css.gridItem}>
          <div className={css.title}>
            Grading Laboratories
          </div>
          <p className={css.text}>
            GIA (Gemological Institute of America) and AGS (American Gem Society) are regarded as the grading standards in the industry, while IGI (International Gemological Institute) is also respected and has leading market share for lab grown diamonds. For natural diamonds, we only work with GIA and AGS certified diamonds to bring you the highest quality and assurances. Our certified lab grown diamonds come with a GIA or IGI certificate.
          </p>
        </GridItem>
        <GridItem col='1/10' customStyle={css.gridItem} />
        <GridItem col='5/10' customStyle={css.gridItem}>
          <div className={css.imageLogosContainer}>
            <img className={css.imageFirstLogo} src={require('./images/logo_gia.png')} />
            <img className={css.imageSecondLogo} src={require('./images/logo_ags.png')} />
            <img className={css.imageThirdLogo} src={require('./images/logo_igi.png')} />
          </div>
        </GridItem>
      </Grid>
    </div>
  )
}

export default GradingLabSection



// WEBPACK FOOTER //
// ./src/containers/diamond/grading_lab_section.js